<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
            is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
            btn-background="bg-gradient-success"
            :dark-mode="true"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">

                <div class="row">
                  <div class="mt-0 card card-plain">
                    <div class="pb-0 card-header text-start">
                      <div style="
                          border: 1px dashed lightgray;
                          box-sizing: border-box;
                          justify-content: center;
                          align-items: center;
                          font-size: 12px;
                        "
                           class="p-3 m-3">
                        <ul>
                          <li>ADMIN: admin // test1234</li>
                          <li>STABLE_MANAGER: stable // test1234 (stable@gmail.com)</li>
                          <li>RIDING_INSTRUCTOR: riding // test1234 (riding@gmail.com)</li>
                          <li>GROOM: groom // test1234 (groom@gmail.com)</li>
                          <li>CUSTOMER: customer // test1234 (customer@gmail.com)</li>
                          <li>VETERINARIAN: veterinarian // test1234 (veterinarian@gmail.com)</li>
                          <li>FERRIER: ferrier // test1234 (ferrier@gmail.com)</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>


          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <div class="pb-0 card-header text-start">
                  <h3 class="font-weight-bolder text-success text-gradient">
                    {{ $t('welcome_back') }}
                  </h3>
                  <!-- <p class="mb-0">{{ $t('enter_email_password') }}</p> -->
                </div>
                <div class="card-body">
                  <form role="form" class="text-start" @submit.prevent="login">
                    <!-- Display error messages -->
                    <p v-if="errorMessage" style="color: red; text-align: center;" class="error">{{ errorMessage }}</p>
                    <label>{{ $t('username') }}</label>
                    <soft-input
                        id="username"
                        type="text"
                        required
                        v-model="username"
                        placeholder="Username"
                        name="username"
                    />
                    <label>{{ $t('password') }}</label>
                    <soft-input
                        id="password"
                        type="password"
                        v-model="password"
                        placeholder="Password"
                        name="password"
                    />
                    <soft-switch id="rememberMe" name="rememberMe" checked>
                      {{ $t('remember_me') }}
                    </soft-switch>
                    <div class="text-center">
                      <soft-button
                          class="my-4 mb-2"
                          variant="gradient"
                          color="success"
                          full-width
                      >{{ $t('sign_in') }}
                      </soft-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    {{ $t('no_account_sign_up') }}
                    <router-link
                        :to="{ name: 'Sign Up' }"
                        class="text-success text-gradient font-weight-bold"
                    >{{ $t('sign_up') }}</router-link
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                  class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8"
              >
                <div
                    class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6"
                    :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/img/curved-images/horse.jpg') +
                      ')',
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer />
</template>

<script>
import Navbar from "@/views/layout/PageLayout/Navbar.vue";
import AppFooter from "@/views/layout/PageLayout/Footer.vue";
import SoftInput from "@/components/SoftInput.vue";
import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import {authService} from "@/services/AuthService";

export default {
  data() {
    return {
      username: '',
      password: '',
      errorMessage: ''
    }
  },
  name: "SignIn",
  components: {
    Navbar,
    AppFooter,
    SoftInput,
    SoftSwitch,
    SoftButton,
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async login(event) {
      try {
        const username = event.target.username.value;
        const password = event.target.password.value;
        // Usa il metodo login del servizio AuthService
        const user = await authService.login(username, password);
        console.log('user: ', user);

        // Se il login ha successo, aggiorna lo stato Vuex e reindirizza
        this.$store.dispatch('fetchUserInfo')
            .then(() => {
              this.$router.push({ name: 'Dashboard' });
            })
            .catch(() => {
              // Se non riesci a recuperare le informazioni utente
              localStorage.removeItem('authToken');
              authService.logout(); // Effettua il logout nel servizio di autenticazione
              this.$store.commit('setUser', {});
              this.$router.push({ name: 'Sign In' });
            });

      } catch (error) {
        // Se il login fallisce, mostra il messaggio di errore
        this.errorMessage = this.$t('error_wrong_username');
      }
    },
  }
};
</script>
